export default __webpack_public_path__ + "static/media/img-slider-cmbus-3.89be1d11.png";